import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { TranslatePipe } from '@techextensor/tab-core-utility';
import { TabSdk } from '@techextensor/tab-sdk';

@Component({
    selector: 'app-confirmation-dialog',
    imports: [CommonModule, TranslatePipe],
    templateUrl: './confirmation-dialog.component.html',
    styleUrl: './confirmation-dialog.component.scss'
})
export class ConfirmationDialogComponent {
  isVisible = false;
  config: any;

  /**
   * The constructor of the confirmation dialog component.
   * It subscribes to the dialog emitter of the confirmation dialog service
   * and updates the config and visibility of the dialog whenever a new
   * configuration is emitted.
   */
  constructor() {
    this.config = this.getDefaultConfig();
    TabSdk.ui.getDialogEmitter().subscribe((config: any) => {
      this.config = {
        ...this.config,
        ...(config ?? {})
      };

      this.isVisible = true;
    });

    TabSdk.ui.getRemoveEmitter().subscribe(() => {
      this.resetDefaltConfig();
    });
  }

  /**
   * Emits a confirmation event and hides the confirmation dialog.
   * This event is emitted when the user clicks the confirm button.
   */
  onConfirm() {
    TabSdk.ui.getConformationEmitter().emit(true);
    this.resetDefaltConfig();
  }

  /**
   * Emits a cancelation event and hides the confirmation dialog.
   * This event is emitted when the user clicks the cancel button.
   */
  onCancel() {
    TabSdk.ui.getConformationEmitter().emit(false);
    this.resetDefaltConfig();
  }

  /**
   * Closes the confirmation dialog without emitting a confirmation event.
   * This is typically called when the user closes the dialog without clicking
   * the confirm or cancel button.
   */
  onClose() {
    // Emit undefined to signal that the dialog was closed without a confirmation event
    TabSdk.ui.getConformationEmitter().emit(undefined);
    // Reset the configuration and visibility of the dialog
    this.resetDefaltConfig();
  }

  /**
   * Resets the configuration and visibility of the confirmation dialog.
   */
  private resetDefaltConfig() {
    this.isVisible = false;
    this.config = this.getDefaultConfig();
  }

  private getDefaultConfig() {
    return {
      title: 'Are you sure you want to Delete',
      message: 'You are about to delete the selected record. Are you sure you want to proceed?',
      primaryOption: 'Ok',
      secondaryOption: 'Cancel',
      displayHeader: true,
      displayFooter: true,
      displayBody: true,
      displayPrimaryButton: true,
      displaySecondaryButton: true,
      displayCloseButton: true
    };
  }
}
